import React, { useEffect, useState } from 'react'
import { Link } from "react-router"
import axios from 'axios'
import Podcast_Feed from './Podcast_Feed'
import Schedule from './Schedule'
import AdditionalLinks from './AdditionalLinks'
import Social_Media from './Social_Media'
import AdditionalLinksBackground from '../images/Additional_Links_Background.png'
import Westbrook_Image from '../images/WESTBROOK_LOGO.png'
import Iridium_Image from '../images/Iridium_Image.png'
import RealRefLogo from '../images/real_ref_report_logo.png'
import "../styles/global_style.css"

const Home = () => {
//     const [schools,setSchools] = useState([])

//     useEffect(()=>{
//         const fetchAllSchools = async ()=>{
//             try {
//                 const res = await axios.get("http://localhost:8800/schools")
//                 setSchools(res.data)
//             } catch (error) {
//                 console.log(error)
//             }
//         }
//         fetchAllSchools()
//     });

//     const handleDelete = async (id) =>{
//         try {
//             await axios.delete("http://localhost:8800/schools/"+id)
//             window.location.reload()
//         } catch (error) {
//             console.log(error)
//         }
//     }

    return (
        <div class="justify-between body_component">
            <div class="">
                <div class="main_box_component large_html" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <Social_Media/>
                </div>
                {/* <div class="main_box_component">
                    <Schedule/>
                </div> */}
            </div>
            <div class="home_center_content_div">
                <h1>Our Mission:</h1>
                <br></br>
                <h3>Here at the WWN our mission is to celebrate and elevate the wrestling community in Washington State by providing a platform that showcases local talent, promotes events, and connects fans, athletes, and coaches.</h3>
                <br></br>
                {/* <div className="sponsors">
                    <h1>Featured Camp:</h1>
                    <a href="https://iridiumwrestling.totalcamps.com/shop/product/449905">
                        <img className="iridium_image_home" src={Iridium_Image} alt="" />
                    </a>
                </div> */}
                <div className="centering_podcasts" >
                    <h2>WWN Podcast</h2>
                    <iframe
                        className="iframe_podcast"
                        style={{ borderRadius: '12px' }}
                        src="https://open.spotify.com/embed/show/33kjRpgGG0EOLtJXoaVHHB/video?utm_source=generator&theme=0&t=0"
                        frameBorder="0"
                        allowFullScreen
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy"
                    ></iframe>
                    <h2>Real Ref Report</h2>
                    <iframe 
                        className="iframe_podcast"
                        style={{ borderRadius: '12px' }} 
                        src="https://open.spotify.com/embed/show/519h7rXp0dfjjoEFUGmn2w/video?utm_source=generator&theme=0"
                        frameBorder="0" 
                        allowfullscreen="" 
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                        loading="lazy"
                        ></iframe>
                </div>
                <div className="sponsors">
                    <img className="westbrook_image_home" src={Westbrook_Image} alt="" />
                </div>
                <br></br>
                
            </div>
            <div class="">
                <div class="main_box_component" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <AdditionalLinks/>
                </div>
                {/* <div class="main_box_component">
                    <Podcast_Feed/>
                </div> */}
            </div>
            <div class="main_box_component small_html" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <Social_Media/>
            </div>
        </div>
    )
}

export default Home
